import { createContext, useContext } from 'react';
import { UserStore } from '../baseUserStore';

export const UserStoreContext = createContext<UserStore | null>(null);

export const useUserStoreContext = (): UserStore => {
  const store = useContext(UserStoreContext);
  if (!store) {
    throw new Error(
      'useUserStoreContext must be used within UserStoreProvider'
    );
  }
  return store;
};
